document.addEventListener('DOMContentLoaded', function () {
    const categoryItems = document.querySelectorAll('.category-item');
    const articlesContainer = document.getElementById('articles-container');
    const loadingSpinner = document.getElementById('loading-spinner');
    const dynamicLink = document.querySelector('.dynamic-category-link');
    const dynamicLinkMobile = document.querySelector('.dynamic-category-link-mobile');

    function loadCategoryArticles(categoryId) {
        // Ajouter la classe "loading" pour afficher le spinner
        articlesContainer.classList.add('loading');

        const xhr = new XMLHttpRequest();
        xhr.open('POST', ajax_object.ajax_url, true);
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

        xhr.onload = function () {
            if (xhr.status === 200) {
                // Insérer le contenu des articles
                articlesContainer.innerHTML = xhr.responseText;

                // Ré-insérer le spinner dans le conteneur
                articlesContainer.appendChild(loadingSpinner);
            }

            // Retirer la classe "loading" une fois terminé
            articlesContainer.classList.remove('loading');
        };

        xhr.send('action=load_articles_by_category_home&category_id=' + categoryId);
    }

    categoryItems.forEach(item => {
        item.addEventListener('click', function () {
            const categoryUrl = this.getAttribute('data-category-url');
            if (dynamicLink) {
                dynamicLink.setAttribute('href', categoryUrl);
            }
            if (dynamicLinkMobile) {
                dynamicLinkMobile.setAttribute('href', categoryUrl);
            }

            categoryItems.forEach(el => el.classList.remove('active'));
            this.classList.add('active');

            const categoryId = this.getAttribute('data-category-id');
            loadCategoryArticles(categoryId);
        });
    });

    if (categoryItems.length > 0) {
        categoryItems[0].classList.add('active');
        const firstCategoryId = categoryItems[0].getAttribute('data-category-id');
        loadCategoryArticles(firstCategoryId);
    }

    if (categoryItems.length > 0 && dynamicLink && dynamicLinkMobile) {
        const firstCategoryUrl = categoryItems[0].getAttribute('data-category-url');
        dynamicLink.setAttribute('href', firstCategoryUrl);
        dynamicLinkMobile.setAttribute('href', firstCategoryUrl);
    }
});
